import { IdIdentifier, Timestamps } from '../common';
import { PaymentProvider } from '../payments/payment.enums';

export type PlanProviderMapping = {
  provider: PaymentProvider;
  externalId: string;
};

export type Plan = IdIdentifier &
  Timestamps & {
    name: string;
    videosPerMonth: number;
    originalPrice?: number;
    price: number;
    credits: number;
    billingCycle: BillingCycle;
    series: number;
    externalId: string;
    providerMappings: PlanProviderMapping[];
    features: string[];
    isActive: boolean;
    isMostPopular?: boolean;
  };

export enum BillingCycle {
  Monthly = 'monthly',
  Annual = 'annual',
  OneTime = 'one-time',
}
